import { useEffect } from "preact/hooks";
import { IFragment } from "../interfaces/fragment";
import { useStatus } from "./status";

export const useAssetLoader = (fragment: IFragment<any>) => {
  const [status, setStatus] = useStatus();

  useEffect(() => {
  }, [fragment]);

  return status;
};

export const loadImageAssets = (srcs: string[], complete: () => void) => {
  if (srcs.length === 0) {
    complete();
    return;
  }
  let count = 0;
  const inc = () => {
    count++;
    if (count === srcs.length) {
      complete();
    }
  };
  srcs.forEach((src) => {
    const img = new Image();
    img.src = src;
    img.onload = inc;
    img.onerror = inc;
  });
};
